module.exports = __webpack_public_path__ + "static/media/global_icon.6118b4e8.svg";